import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEditUserDialogComponent } from './add-edit-user-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule, MaterialModule, SharedModule } from 'components';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    AddEditUserDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    SharedModule,
    MaterialModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule
  ]
})
export class AddEditUserDialogModule { }
